import { createElement } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { PriceAmount } from '@polycard/price-amount';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
const BoxStyleStyles = ['background_color_hex'];
const BoxClassStyles = ['background_color'];
const BoxStyles = [...BoxStyleStyles, ...BoxClassStyles];
const TextStyleStyles = ['color_hex', 'background_color_hex'];
const TextClassStyles = ['color', 'font_size', 'font_weight', 'line_height', 'text_transform', 'background_color'];
const TextStyles = [...TextStyleStyles, ...TextClassStyles];
const isIncludeTextStyles = styles => Boolean(styles && TextStyles.some(item => Object.keys(styles).includes(item)));
const isIncludeBoxStyles = styles => Boolean(styles && BoxStyles.some(item => Object.keys(styles).includes(item)));
const boxClassDefault = {};
const getBoxClasses = styles => {
  if (isIncludeBoxStyles(styles)) {
    // @ts-expect-error there is at interface
    const keysToInclude = Object.keys(styles).filter(item => BoxClassStyles.includes(item));
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const st = styles;
    return keysToInclude.map(item => ({
      [item]: st[item]
    })).reduce((prev, curr) => _extends({}, prev, curr), {});
  }
  return boxClassDefault;
};
const boxStyleDefault = {};
const getBoxStyles = styles => {
  if (isIncludeBoxStyles(styles)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const st = styles;
    return {
      background_color_hex: st == null ? void 0 : st.background_color_hex
    };
  }
  return boxStyleDefault;
};
const textStyleDefault = {};
const getTextStyles = styles => {
  if (isIncludeTextStyles(styles)) {
    return _extends({}, styles != null && styles.color_hex ? {
      color_hex: styles == null ? void 0 : styles.color_hex
    } : {}, styles != null && styles.background_color_hex ? {
      background_color_hex: styles == null ? void 0 : styles.background_color_hex
    } : {});
  }
  return textStyleDefault;
};
const getTextClasses = styles => {
  if (isIncludeTextStyles(styles)) {
    // @ts-expect-error there is at interface
    const keysToInclude = Object.keys(styles).filter(item => TextClassStyles.includes(item));
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const st = styles;
    return keysToInclude.map(item => ({
      [item]: st[item]
    })).reduce((prev, curr) => _extends({}, prev, curr), {});
  }
  return {};
};
const FontSizes = {
  xxs: 10,
  xs: 12,
  s: 14,
  xm: 16,
  m: 18,
  l: 20,
  xl: 24,
  xxl: 28,
  xxxl: 32,
  huge: 44
};
const fontSizeDefault = 'xm';
const isValidFontSize = fontSize => Boolean(fontSize && Object.keys(FontSizes).includes(fontSize));
const FontWeights = ['light', 'regular', 'semibold', 'bold'];
const fontWeightDefault = 'regular';
const isValidFontWeight = fontWeight => Boolean(fontWeight && FontWeights.includes(fontWeight));
const LineHeights = {
  xxs: 1,
  xs: 1.15,
  s: 1.25,
  xm: 1.35,
  m: 1.45,
  l: 1.56,
  xl: 1.79,
  xxl: 2.03,
  xxxl: 2.26,
  huge: 2.5
};
const lineHeightDefault = 'xm';
const isValidLineHeight = lineHeight => Boolean(lineHeight && Object.keys(LineHeights).includes(lineHeight));
const TextTransforms = ['capitalize', 'uppercase', 'lowercase', 'none'];
const textTransformDefault = 'none';
const isValidTextTransform = textTransform => Boolean(textTransform && TextTransforms.includes(textTransform));
const colorValidationRegex = /^#[0-9a-fA-F]{8}$|#[0-9a-fA-F]{6}$|#[0-9a-fA-F]{4}$|#[0-9a-fA-F]{3}$/;
const Colors = ['primary', 'secondary', 'disabled', 'inverted', 'attention', 'negative', 'negative-secondary', 'caution', 'caution-secondary', 'positive', 'positive-secondary', 'accent', 'accent-secondary'];
const isValidColor = color => Boolean(color && Colors.includes(color));
const isValidColorHex = color => Boolean(color && colorValidationRegex.test(color));
const bgColorDefault = 'inverted';
const textColorDefault = 'primary';
const mapperFontSizeToSize = {
  xxs: 12,
  xs: 12,
  s: 14,
  xm: 16,
  m: 18,
  l: 20,
  xl: 24,
  xxl: 28,
  xxxl: 32,
  huge: 44
};
const sizeMapperDefault = 'inherit';
const getSizeByFontSize = font_size => {
  if (isValidFontSize(font_size)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const size = font_size;
    return mapperFontSizeToSize[size];
  }
  return sizeMapperDefault;
};
const ICONSVIEWBOX = {
  poly_black_friday: '0 0 12 12',
  poly_bookmark: '0 0 20 20',
  poly_calendar: '0 0 14 14',
  poly_cbt: '0 0 154 16',
  poly_cpg: '0 0 106 10',
  poly_close: '0 0 14 14',
  poly_cockade: '0 0 12 12',
  poly_compats: '0 0 16 16',
  poly_installation_services: '0 0 16 16',
  poly_coupon: '0 0 13 11',
  poly_file: '0 0 16 16',
  poly_full: '0 0 41 13',
  poly_full_super: '0 0 91 18',
  poly_full_super_mlb: '0 0 91 18',
  poly_meli_plus: '0 0 43 16',
  poly_meli: '0 0 18 13',
  poly_melicoin: '0 0 19 19',
  poly_size_chart: '0 0 19 11',
  poly_star_fill: '0 0 15 15',
  poly_star_half: '0 0 15 15',
  poly_star: '0 0 15 15',
  poly_tour: '0 0 21 13',
  poly_trade_in: '0 0 16 16',
  poly_warning: '0 0 16 16'
};

/**
 * acronym: Not Supported in HTML5.
 * var, tt: Not Supported by JSX.IntrinsicElements then there were remove.
 */
const Inlines = ['a', 'abbr', 'b', 'bdo', 'big', 'br', 'button', 'cite', 'code', 'dfn', 'em', 'i', 'img', 'input', 'kbd', 'label', 'map', 'object', 'output', 'q', 'samp', 'script', 'select', 'small', 'span', 'strong', 'sub', 'sup', 'textarea', 'time', 'p'];
const getInlineDefault = () => 'span';
const getInlines = () => Inlines;
const Blocks = ['article', 'aside', 'blockquote', 'details', 'dialog', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'li', 'main', 'nav', 'ol', 'p', 'pre', 'section', 'table', 'ul'];
const getBlockDefault = () => 'div';
const getBlocks = () => Blocks;
const IconPhraseDefault = {
  bf_v6_coupons: 'coupon',
  black_friday_icon: 'black_friday',
  buflo_congrats_information_cbt: 'cbt',
  buflo_reference_installation: 'installation_services',
  ic_online_visit_request: 'calendar',
  icon_black_friday: 'black_friday',
  icon_bookmark: 'bookmark',
  icon_cbt: 'cbt',
  icon_close: 'close',
  icon_cockade: 'cockade',
  icon_file: 'file',
  icon_full_super_mlb: 'full_super_mlb',
  icon_full_super: 'full_super',
  icon_full: 'full',
  icon_meli_plus: 'meli_plus',
  icon_meli: 'meli',
  icon_melicoin: 'melicoin',
  icon_star_fill: 'star_fill',
  icon_star_half: 'star_half',
  icon_star: 'star',
  icon_tour: 'tour',
  icon_trade_in: 'trade_in',
  icon_warning: 'warning',
  meli_icon: 'meli',
  melichoice_new_icon: 'meli',
  meliplus_icon: 'meli_plus',
  polycard_virtual_tour_icon: 'tour',
  size_chart_icon: 'size_chart',
  spotlight_compatible_green_icon: 'compats',
  supermarket_logo: 'cpg',
  vip_gallery_tour_icon: 'tour',
  vpp_bookmark_icon: 'bookmark',
  vpp_full_icon: 'full',
  vpp_warning_icon: 'warning'
};
const getIconDefault = () => Object.keys(IconPhraseDefault).map(item => ({
  key: item,
  type: 'icon',
  icon: {
    key: IconPhraseDefault[item]
  }
}));
const addIconDefaultProps = values => {
  if (!values || values.length === 0 || typeof values === 'string') return getIconDefault();
  const iconsValues = values.filter(item => item.type === 'icon'); // identifico si existe algun Value con type icon
  const noIconsValues = values.filter(item => item.type !== 'icon');
  if (iconsValues.length > 0) {
    // si existe algun Value con type icon y key en el mapper, remplazo sus values por los values que necesita front, sino retorno el icon como venga
    const addValues = iconsValues.map(item => {
      if (Object.keys(IconPhraseDefault).includes(item.key)) {
        return {
          key: item.key,
          type: 'icon',
          icon: _extends({}, item == null ? void 0 : item.icon, {
            key: IconPhraseDefault[item.key]
          }) // remplazo el key del icono por el key que necesita front, conservando los demas values (src , alt, etc)
        };
      }
      return item;
    });
    return [...noIconsValues, ...addValues]; // retorno los values que no son iconos y los iconos con los values que necesita front
  }
  return [...noIconsValues];
};
const reduceArrayWithoutRepeats = (prev, curr) => {
  const isAlgo = prev.includes(curr);
  if (isAlgo) return prev;
  return [...prev, curr];
};
const reduceStringWithoutRepeats = (prev, curr) => {
  if (prev.includes(curr)) return prev;
  return prev + curr;
};
const regex = /{(.*?)}/gm;
const matcher = text => text == null ? void 0 : text.match(regex);
const getKeyValues = values => {
  if (!values) return {
    keys: [],
    types: []
  };
  const result = {
    keys: values.map(item => `{${item.key}}`),
    types: values.map(item => {
      var _item$type;
      return (_item$type = item == null ? void 0 : item.type) != null ? _item$type : 'label';
    })
  };
  return result;
};
const getCandidate = (values, key) => {
  const candidate = Array.isArray(values) ? values.filter(item => {
    const result = key.indexOf(`{${item.key}}`) > -1 ? item : false;
    return result;
  }) : [];
  return candidate;
};
const removeInterpolations = text => {
  const matchValue = matcher(text);
  if (!matchValue) return text;
  let newText = text;
  matchValue.forEach(keyExpression => {
    newText = newText.replace(keyExpression, '');
  });
  return newText.trim();
};
const getInterpolateChunks = (values, text) => {
  if (!values || values.length === 0 || !text || !matcher(text)) return null;
  const {
    keys
  } = getKeyValues(values);
  const chunkByBlank = text.split(regex).filter(i => i);
  return chunkByBlank.flatMap(chunk => {
    const chunkByKeys = keys.flatMap(el => el.replace('{', '').replace('}', '') === chunk ? el : '');
    const res = chunkByKeys.reduce(reduceArrayWithoutRepeats, []).reduce(reduceStringWithoutRepeats, '');
    return res === '' ? chunk : res;
  });
};
function* generateStaticKey(valueType) {
  let counter = 0;
  while (true) {
    // eslint-disable-next-line no-plusplus
    yield `${valueType}-${counter++}`;
  }
}
const phraseNamespace = 'poly';
const getModuleByClassName = className => {
  const classes = className.split(' ').map(classNameSplitted => {
    if (classNameSplitted) return `${phraseNamespace}-${classNameSplitted}`;
    return '';
  });
  return classes.join(' ');
};
const getBoxColor = (objectStyle, itemStyle) => {
  if (itemStyle === 'background_color_hex') return objectStyle[itemStyle];
  return '';
};
const getBoxStyle = styles => {
  const objectStyle = getBoxStyles(styles);
  const result = Object.keys(objectStyle).map(item => {
    const hexColor = getBoxColor(objectStyle, item);
    const isValidColor = isValidColorHex(hexColor);
    if (isValidColor) {
      return {
        backgroundColor: hexColor
      };
    }
    return {};
  }).reduce((prev, curr) => _extends({}, prev, curr), {});
  return result;
};
const getBgColorClass = textColor => {
  if (isValidColor(textColor)) return `bg-${textColor}`;
  return `bg-${bgColorDefault}`;
};
const getTextColorClass = textColor => {
  if (isValidColor(textColor)) return `text-${textColor}`;
  return `text-${textColorDefault}`;
};
const getBoxClassName = (objectStyle, item) => {
  if (item === 'background_color') {
    return getBgColorClass(objectStyle[item]);
  }
  return '';
};
const getBoxClass = styles => {
  const objectStyle = getBoxClasses(styles);
  const result = Object.keys(objectStyle).map(item => {
    const className = getBoxClassName(objectStyle, item);
    return getModuleByClassName(className);
  }).reduce((prev, curr) => `${prev} ${curr}`, '');
  return result.trim();
};
const getTextColor = (objectStyle, item) => {
  if (item === 'color_hex') return objectStyle[item];
  return '';
};
const getTextBoxColor = (objectStyle, itemStyle) => {
  if (itemStyle === 'background_color_hex') return objectStyle[itemStyle];
  return '';
};
const getTextStyle = styles => {
  const objectStyle = getTextStyles(styles);
  const result = objectStyle && Object.keys(objectStyle).map(item => {
    const hexColor = getTextColor(objectStyle, item);
    const hexBgColor = getTextBoxColor(objectStyle, item);
    const isValid = isValidColorHex(hexColor);
    const isBgValid = isValidColorHex(hexBgColor);
    return _extends({}, isValid ? {
      color: hexColor
    } : {}, isBgValid ? {
      backgroundColor: hexBgColor
    } : {});
  }).reduce((prev, curr) => _extends({}, prev, curr), {}) || {};
  return result;
};
const getFontSizeClass = textSize => {
  if (isValidFontSize(textSize)) return `fs-${textSize}`;
  return `fs-${fontSizeDefault}`;
};
const getFontWeightClass = fontWeight => {
  if (isValidFontWeight(fontWeight)) return `fw-${fontWeight}`;
  return `fw-${fontWeightDefault}`;
};
const getLineHeightClass = lineHeight => {
  if (isValidLineHeight(lineHeight)) return `lh-${lineHeight}`;
  return `lh-${lineHeightDefault}`;
};
const getTextTransformClass = textTransform => {
  if (isValidTextTransform(textTransform)) return `tt-${textTransform}`;
  return `tt-${textTransformDefault}`;
};
const getTextClassName = (objectStyle, item) => {
  if (item === 'color') {
    return getTextColorClass(objectStyle[item]);
  }
  if (item === 'background_color') {
    return getBgColorClass(objectStyle[item]);
  }
  if (item === 'font_size') {
    return getFontSizeClass(objectStyle[item]);
  }
  if (item === 'font_weight') {
    return getFontWeightClass(objectStyle[item]);
  }
  if (item === 'line_height') {
    return getLineHeightClass(objectStyle[item]);
  }
  if (item === 'text_transform') {
    return getTextTransformClass(objectStyle[item]);
  }
  return '';
};
const getTextClass = styles => {
  const objectStyle = getTextClasses(styles);
  const result = Object.keys(objectStyle).map(item => {
    const className = getTextClassName(objectStyle, item);
    return getModuleByClassName(className);
  }).reduce((prev, curr) => `${prev} ${curr}`, '');
  return result.trim();
};
const getBlockComponent = as => {
  if (as && getBlocks().includes(as)) return as;
  return getBlockDefault();
};
const getProps = (className, href, isAriaHidden, style, target, handleClick) => {
  const base = {
    className
  };
  const props = _extends({}, style ? {
    style
  } : {}, href ? {
    href
  } : {}, handleClick ? {
    onClick: handleClick
  } : {}, target ? {
    target
  } : {}, isAriaHidden ? {
    'aria-hidden': `${isAriaHidden}`
  } : {});
  return _extends({}, base, props);
};
const getInlineComponent = (as, url) => {
  if (url) return 'a';
  if (as && getInlines().includes(as)) return as;
  return getInlineDefault();
};
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
const extractWidthAndHeight = viewBox => {
  const parts = viewBox ? viewBox.split(' ') : [];
  return {
    width: parts[2],
    height: parts[3]
  };
};
const SvgBuilder = _ref => {
  let {
    icon,
    className,
    aria_label,
    isAriaHidden,
    width,
    height
  } = _ref;
  const iconViewBox = ICONSVIEWBOX[`poly_${icon}`];
  const iconClass = classNames(className, {
    poly_empty_star: icon === 'star'
  });
  return (
    /* To support add andes icon like a response but now we add any andes icon
    import { getBuilder } from '../../../utils';
    const [vector, AndesIcon] = getBuilder(icon);
    if (AndesIcon) return <AndesIcon color={vector?.andesColor} />;
    */
    jsxs("svg", {
      className: iconClass || undefined,
      width: extractWidthAndHeight(iconViewBox).width || width,
      height: extractWidthAndHeight(iconViewBox).height || height,
      viewBox: iconViewBox,
      role: aria_label ? 'img' : undefined,
      "aria-hidden": isAriaHidden,
      "aria-label": aria_label,
      children: [jsx("use", {
        href: `#poly_${icon}`
      }), icon === 'meli_plus' ? jsxs("linearGradient", {
        id: "paint0_linear_8761_4741",
        x1: "0",
        y1: "7.98613",
        x2: "42.0833",
        y2: "7.98613",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          offset: "0.298365",
          stopColor: "#5A238D"
        }), jsx("stop", {
          offset: "1",
          stopColor: "#AA1192"
        })]
      }) : null]
    })
  );
};
const Icon = _ref => {
  let {
    icon,
    src,
    aria_label,
    alt_text,
    isAriaHidden,
    className,
    iconClassName
  } = _ref;
  return !src ? jsx(SvgBuilder, {
    icon: icon,
    className: iconClassName,
    aria_label: aria_label || alt_text,
    isAriaHidden: isAriaHidden
  }) : jsx("img", {
    src: src,
    alt: aria_label,
    className: className,
    width: 24,
    height: 24,
    "aria-hidden": isAriaHidden
  });
};
const IconPropsDefault = {
  key: undefined
};
const getIconPropsByKeys = (values, key) => {
  const candidate = getCandidate(values, key);
  if (candidate.length > 0) {
    return _extends({}, candidate[0].icon);
  }
  return IconPropsDefault;
};
const _excluded$1 = ["key"];
const IconPhrase = _ref => {
  let {
    values,
    item,
    className,
    iconClassName
  } = _ref;
  const iconProps = getIconPropsByKeys(values, item);
  const candidate = getCandidate(values, item);
  const {
      key: iconKey
    } = iconProps,
    restIconProps = _objectWithoutPropertiesLoose(iconProps, _excluded$1);
  const props = _extends({}, restIconProps, {
    className,
    iconClassName,
    icon: iconKey || IconPhraseDefault[candidate[0].key]
  });
  return jsx(Icon, _extends({}, props), iconKey);
};
const PricePropsDefault = {
  value: 0,
  currency: undefined,
  thousandSeparator: '.',
  decimalSeparator: ',',
  styles: undefined
};
const getPricePropsByKeys = (key, values, thousandSeparator, decimalSeparator) => {
  const candidate = getCandidate(values, key);
  if (candidate.length > 0) {
    var _price$value, _price$size, _price$currency, _price$decimal_style, _price$compact;
    const {
      styles,
      price
    } = candidate[0];
    const value = (_price$value = price == null ? void 0 : price.value) != null ? _price$value : 0;
    const size = (_price$size = price == null ? void 0 : price.size) != null ? _price$size : undefined;
    const currency = (_price$currency = price == null ? void 0 : price.currency) != null ? _price$currency : undefined;
    const decimal_style = (_price$decimal_style = price == null ? void 0 : price.decimal_style) != null ? _price$decimal_style : undefined;
    const compact = (_price$compact = price == null ? void 0 : price.compact) != null ? _price$compact : undefined;
    const isAriaHidden = price == null ? void 0 : price.isAriaHidden;
    const aria_label = price == null ? void 0 : price.aria_label;
    return {
      value,
      size,
      currency,
      decimal_style,
      thousandSeparator,
      decimalSeparator,
      styles,
      compact,
      isAriaHidden,
      aria_label
    };
  }
  return PricePropsDefault;
};
const _excluded = ["styles"];
const PricePhrase = _ref => {
  let {
    item,
    values,
    thousandSeparator,
    decimalSeparator
  } = _ref;
  const _getPricePropsByKeys = getPricePropsByKeys(item, values, thousandSeparator, decimalSeparator),
    {
      styles
    } = _getPricePropsByKeys,
    pricePropsByKey = _objectWithoutPropertiesLoose(_getPricePropsByKeys, _excluded);
  const props = _extends({}, pricePropsByKey, {
    className: classNames(`${phraseNamespace}-phrase-price`, getTextClass(styles))
  });
  return jsx(PriceAmount, _extends({}, props));
};
const getStyleByKeys = (values, key) => {
  const candidate = getCandidate(values, key);
  if (candidate.length > 0) {
    var _candidate$0$label$te, _candidate$0$label, _candidate$, _candidate$0$label2, _candidate$0$label3, _candidate$0$label4, _candidate$0$label5;
    const typeKey = `{${candidate[0].key}}`;
    const text = (_candidate$0$label$te = (_candidate$0$label = candidate[0].label) == null ? void 0 : _candidate$0$label.text) != null ? _candidate$0$label$te : '';
    const children = key.replace(typeKey, text);
    const styles = (_candidate$ = candidate[0]) == null ? void 0 : _candidate$.styles;
    const isAriaHidden = (_candidate$0$label2 = candidate[0].label) == null ? void 0 : _candidate$0$label2.isAriaHidden;
    const aria_label = (_candidate$0$label3 = candidate[0].label) == null ? void 0 : _candidate$0$label3.aria_label;
    const url = (_candidate$0$label4 = candidate[0].label) == null ? void 0 : _candidate$0$label4.url;
    const target = (_candidate$0$label5 = candidate[0].label) == null ? void 0 : _candidate$0$label5.target;
    return {
      children,
      styles,
      isAriaHidden,
      aria_label,
      url,
      target
    };
  }
  const className = undefined;
  const children = '';
  const styles = {};
  return {
    children,
    styles,
    className
  };
};
const Box = _ref => {
  let {
    children,
    as,
    style,
    className
  } = _ref;
  const Component = getBlockComponent(as);
  const newClassName = classNames(`${phraseNamespace}-box`, className);
  return jsx(Component, {
    className: newClassName,
    style: style,
    children: children
  });
};
const Text = _ref => {
  let {
    children,
    as,
    url,
    isAriaHidden,
    className,
    style,
    target,
    id,
    item_ids_for_removal,
    aria_label,
    onClick
  } = _ref;
  const Component = getInlineComponent(as, url);
  const newClassName = classNames(className);
  const handleClick = event => {
    if (onClick) {
      onClick(event, {
        url,
        id,
        item_ids_for_removal
      });
    }
  };
  const props = getProps(newClassName, url, isAriaHidden, style, target, handleClick);
  return jsx(Component, _extends({}, props, aria_label && {
    'aria-label': aria_label
  }, {
    children: children
  }));
};
const Wrapper = _ref => {
  let {
    children,
    styles,
    asBox,
    asText,
    url,
    isAriaHidden,
    className,
    target,
    id,
    item_ids_for_removal,
    aria_label,
    onClick
  } = _ref;
  const textStyle = getTextStyle(styles);
  const textClass = getTextClass(styles);
  if (asBox) {
    const boxStyle = getBoxStyle(styles);
    const boxClass = getBoxClass(styles);
    const textInBoxStyles = Object.entries(textStyle).reduce((result, _ref2) => {
      let [key, value] = _ref2;
      let updatedResult = _extends({}, result);
      if (!Object.prototype.hasOwnProperty.call(boxStyle, key) || boxStyle[key] !== value) {
        updatedResult = _extends({}, updatedResult, {
          [key]: value
        });
      }
      return updatedResult;
    }, {});
    return jsx(Box, {
      as: asBox,
      className: classNames(className, boxClass),
      style: boxStyle,
      children: jsx(Text, {
        url: url,
        as: asText,
        style: textInBoxStyles,
        className: textClass,
        id: id,
        item_ids_for_removal: item_ids_for_removal,
        onClick: onClick,
        isAriaHidden: isAriaHidden,
        aria_label: aria_label,
        children: children
      })
    });
  }
  const isNeedTextWrapper = isIncludeTextStyles(styles);
  if (isNeedTextWrapper || asText) {
    return jsx(Text, {
      as: asText,
      url: url,
      isAriaHidden: isAriaHidden,
      id: id,
      item_ids_for_removal: item_ids_for_removal,
      onClick: onClick,
      className: classNames(className, textClass),
      style: textStyle,
      target: target,
      aria_label: aria_label,
      children: children
    });
  }
  return children;
};
const LabelPhrase = _ref => {
  let {
    values,
    item
  } = _ref;
  const props = _extends({}, getStyleByKeys(values, item));
  return jsx(Wrapper, _extends({}, props));
};
const getComponent = type => {
  const components = {
    icon: IconPhrase,
    price: PricePhrase
  };
  return components[type] || LabelPhrase;
};
const getValuesWithStyles = oldStyles => item => {
  const {
    styles: currentStyle,
    price: oldPrice = {},
    type = ''
  } = item;
  const styles = _extends({}, oldStyles, currentStyle);
  const size = getSizeByFontSize(oldStyles == null ? void 0 : oldStyles.font_size);
  const price = _extends({}, oldPrice, {
    compact: true,
    size
  });
  return type === 'price' ? _extends({}, item, {
    styles,
    price
  }) : _extends({}, item, {
    styles
  });
};
const generateLocalKeys = (count, valueType) => {
  const keyGenerator = generateStaticKey(valueType);
  return Array.from({
    length: count
  }, () => keyGenerator.next().value);
};
const Phrase = _ref => {
  let {
    alt_text,
    aria_label = alt_text,
    asBox = undefined,
    asText,
    className = '',
    decimalSeparator = undefined,
    iconClassName = '',
    id,
    isAriaHidden,
    isAsText = true,
    item_ids_for_removal,
    onClick,
    styles,
    target,
    text = '',
    thousandSeparator = undefined,
    url,
    values: oldValues
  } = _ref;
  const finalAsText = isAsText ? asText || 'span' : undefined;
  const valuesWithIconsDefaults = addIconDefaultProps(oldValues);
  const elements = getInterpolateChunks(valuesWithIconsDefaults, text);
  if (!elements) {
    const wrapperProps = {
      styles,
      className,
      asBox,
      url,
      target,
      id
    };
    const otherProps = {
      item_ids_for_removal,
      isAriaHidden,
      aria_label,
      onClick
    };
    return jsx(Wrapper, _extends({}, wrapperProps, otherProps, {
      asText: finalAsText,
      children: removeInterpolations(text)
    }));
  }
  const keyValues = getKeyValues(valuesWithIconsDefaults);
  const values = valuesWithIconsDefaults == null ? void 0 : valuesWithIconsDefaults.map(getValuesWithStyles(styles));
  const otherProps = {
    isAriaHidden,
    aria_label,
    onClick,
    item_ids_for_removal
  };
  const wrapperProps = {
    styles,
    className,
    asBox,
    url,
    target,
    id,
    asText: finalAsText
  };
  return jsx(Wrapper, _extends({}, wrapperProps, otherProps, {
    children: elements.map((item, index) => {
      const keyIncludeItem = item.split(' ').filter(el => keyValues.keys.includes(el));
      if (keyIncludeItem.length > 0) {
        const valueIndex = keyValues.keys.indexOf(keyIncludeItem[0]);
        const valueType = keyValues.types[valueIndex];
        const key = generateLocalKeys(keyIncludeItem.length, valueType);
        const Component = getComponent(valueType);
        return keyIncludeItem.map((keyItem, keyItemIndex) => jsx(Component, _extends({
          item: keyItem,
          values: values
        }, valueType === 'price' && {
          thousandSeparator,
          decimalSeparator
        }, valueType === 'icon' && iconClassName && {
          iconClassName
        }), key[keyItemIndex]));
      }
      const keyText = generateLocalKeys(1, `text-${index}`);
      const props = {
        className,
        isAriaHidden,
        aria_label
      };
      return /*#__PURE__*/createElement(Wrapper, _extends({}, props, {
        key: keyText[0]
      }), item);
    })
  }));
};
export { Phrase, SvgBuilder };
